import {connect} from 'react-redux';
import {Poster as Component} from './Poster';
import {
  showModal,
  masterMixViewed,
  thermocyclerViewed
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    levelSelected: state.notebook.levelSelected
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    masterMixViewed: (data) => {
      dispatch(masterMixViewed(data))
    },
    thermocyclerViewed: (data) => {
      dispatch(thermocyclerViewed(data))
    }
  };
}

export const Poster = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
